import { Button, Input, Table, Checkbox, Card, Space, Typography, message, Modal } from 'antd';
import axios from 'axios';
import { useState } from 'react';
import { useQuery } from 'react-query';

import { articlesService } from 'config/services';

import { transformResource } from 'routes/articles/utils';

import { Article } from 'types/services/articles';

const { Column } = Table;
const { Title } = Typography;

const Newsletter = () => {
  const [selectedArticles, setSelectedArticles] = useState<Article[]>([]);
  const [newsletterTitle, setNewsletterTitle] = useState<string>('');
  const [isSending, setIsSending] = useState<boolean>(false);
  const [searchTerm, setSearchTerm] = useState<string>(''); // 🔹 Added search state
  const [latestPage, setLatestPage] = useState(1);
  const [mostReadPage, setMostReadPage] = useState(1);
  const [confirmVisible, setConfirmVisible] = useState(false);

  // ──────────────────────────────────────────────────────────────────────────
  // 1) FETCH NEWEST ARTICLES
  const { data: response, isLoading } = useQuery<{ data: Article[] }>('listArticles', () =>
    articlesService.list({ page: 1, perPage: 1000 }, {}),
  );
  const articles: Article[] | any[] = response ? response.data : [];

  const filteredArticles = articles.filter((article) => article.title.toLowerCase().includes(searchTerm.toLowerCase()));

  const { data: banners = [] } = useQuery('newsletterBanners', async () => {
    const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/newsletter-banners`);
    return res.data;
  });

  function transform(arts: Article[], stats: any) {
    return arts.map((article) => transformResource(article, []));
  }

  // ──────────────────────────────────────────────────────────────────────────
  // 2) FETCH MOST READ ARTICLES (INCLUDES numberOfHits)
  const fetchMostReadArticles = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/articles/most-read`);

      console.log('API Response:', response.data); // Debugging API response

      // Handling different response structures properly
      if (response.data?.mostread?.data) {
        return response.data.mostread.data;
      } else if (response.data?.data) {
        return response.data.data;
      }

      return []; // Ensure an empty array instead of undefined
    } catch (error) {
      console.error('Error fetching most read articles:', error);
      return []; // Return empty array on failure to avoid breaking the UI
    }
  };

  const { data: mostReadResponse, isLoading: isLoadingMostRead } = useQuery(
    ['mostReadArticles'],
    fetchMostReadArticles,
    {
      staleTime: 5 * 60 * 1000, // Cache for 5 minutes
      retry: 2, // Retry twice before failing
    },
  );

  // Ensure it's always an array to prevent rendering issues
  const mostReadArticles: Article[] | any[] = Array.isArray(mostReadResponse) ? transform(mostReadResponse, []) : [];

  console.log(mostReadArticles, 'MOSTREAD');

  // ──────────────────────────────────────────────────────────────────────────
  // Handle selecting/deselecting articles from either table
  const handleSelectArticle = (article: Article, checked: boolean) => {
    setSelectedArticles((prev) => (checked ? [...prev, article] : prev.filter((a) => a.id !== article.id)));
  };

  // ──────────────────────────────────────────────────────────────────────────
  // Helper to format date in your HTML template
  const formatDate = (date: Date) => {
    const months = [
      'Januar',
      'Februar',
      'Mart',
      'April',
      'Maj',
      'Juni',
      'Juli',
      'August',
      'Septembar',
      'Oktobar',
      'Novembar',
      'Decembar',
    ];
    const day = date.getDate();
    const month = months[date.getMonth()];
    const year = date.getFullYear();
    return `${day} ${month}, ${year}`;
  };

  // ──────────────────────────────────────────────────────────────────────────
  // Generate Newsletter (Single Template)
  const generateNewsletter = () => {
    const formattedDate = formatDate(new Date());
    return `
       <!DOCTYPE html>
<html lang="bs">

<head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>Avaz Newsletter</title>

    <style>
        body {
            font-family: Arial, sans-serif;
            background-color: white;
            margin: 0;
            padding: 0;
            width: 100%;
        }

        .container {
            width: 100%;
            max-width: 700px;
            background-color: #ffffff;
            margin: 20px auto;
            border-radius: 8px;
            box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
            display: flex;
            flex-direction: column;
            align-items: center;
        }

        .header {
            text-align: center;
            width: 80%;
            display: block;
        }

        .header img {
            max-width: 80%;
            height: auto;
            display: block;
            margin: 0 auto;
        }

        .stamp-row {
            align-items: baseline;
        }

        .center-col {
            text-align: center;
        }

        /* centers everything  */
        .full-img {
            width: 100%;
            max-width: 360px;
            border-radius: 6px;
        }

        .small-hr {
            border: 0;
            height: 8px;
            background: #D50000;
            width: 100%;
            max-width: 360px;
            margin: 0 auto 15px;
        }


        .title {
            font-size: 60px;
            font-weight: bold;
            text-align: center;
            margin: 15px 0;
            display: block;
            color: #EC2128;
            justify-content: flex-start;
            font-family: 'DM Sans', sans-serif;

        }

        .paginacija {
            font-size: 100px;
            color: #E0E0E0;
            line-height: 1;
            font-family: 'Didot', 'Bodoni', 'Playfair Display', serif;
        }

        .date {
            text-align: center;
            color: #666;
            font-size: 17px;
            display: block;
            margin-bottom: 15px;
            padding-top: 25px;
        }

        .glavniHr {

            border: 0;
            height: 8px;
            background: #D50000;
            width: 100%;
            margin-top: 0px;


        }

        .article {
            display: flex;
            align-items: center;
            gap: 20px;
            padding: 20px 0;
            border-bottom: 1px solid #ddd;
            padding-bottom: 30px;
        }

        .article img {
            width: 100%;
            height: auto;
            object-fit: cover;
            border-radius: 6px;
            margin-bottom: 10px;
            display: block;
        }

        .article-content {
            flex: 1;
            display: block;
        }

        .article h2 {
            font-size: 18px;
            color: #383435;
            margin: 0 0 5px;
        }

        .article p {
            font-size: 40px;
            color: #231F20;
            margin: 0;
        }

        .obav {
            font-family: 'Google Sans', Roboto, Arial, sans-serif;
            font-size: 18px;
            max-width: 75%;
            color: #383435;
            margin-bottom: 50px;
        }

        .read-more {
            display: block;
            text-align: left;
            color: #d32f2f;
            font-weight: bold;
            text-decoration: none;
            margin-top: 8px;
        }

        .footer {
            text-align: center;
            padding: 15px;
            font-size: 12px;
            color: #666;
            display: block;
            width: 100%;
        }

        .adContainer {
            align-items: center;
            justify-content: center;
            align-self: center;
        }

        .unsubscribe {
            text-align: center;
            margin-top: 10px;
            display: block;
            width: 100%;
            font-size: 20px;
        }

        .container-slike {
            paddding-top: 15px;

        }

        .middlePart{
              width:74%;
        }

        .sideParts{
              width:13%;
        }

        .sideParts{
          justify-content:center;
        }


        /* New, more granular mobile breakpoint for devices up to 600px */
        @media only screen and (max-width: 700px) {
            .container {

                padding: 10px;
                max-width: 92% !important;
            }

            /* Stamps: hide desktop copy, show mobile copy */
            .stamp-desktop {
                display: none !important;
            }

            .stamp-mobile {
                display: block !important;
            }



            .title {
                font-size: 68px;
            }

            .paginacija {
                font-size: 43px !important;
                line-height:43px!important;
            }

            .stamp-text {
                font-size: 15px !important;
            }

            .govno {

                width: 100% !important;

            }

            .slikica {
                max-width: 240px !important;
                /* ≈ 2⁄3 of the desktop size   */
                width: 80% !important;
                /* or any % you prefer         */
                margin-left: 17px !important;
                /* stop it from shifting right */
            }

            h1.heading-word {
                font-size: 14px !important;
            }

            .article-titleX {
                font-size: 18px !important;
                line-height:20px!important;
            }

            .articleSubtitle {
                font-size: 16px !important;
                line-height:17px!important;
            }

            .article {

                align-items: flex-start !important;
                gap: 12px !important;
            }

            .article img {
                width: 100% !important;
                height: auto !important;
                margin:0 auto!important;
            }

            .obav {
                font-size: 16px;
                max-width: 100%;
            }

            .article-title {
                font-size: 15px !important;
                line-height: 24px !important;
                margin-left: 0px !important;
            }

            .read-more {
                font-size: 18px;
            }



            /* Hide huge number & make wrapper fit */
            .article-wrap {
                width: 100% !important;
            }


            .footer h3 {
                font-size: 24px;
            }

            .footer p,
            .date {
                font-size: 14px;
            }

            /* ====== fix horizontal overflow on mobile ====== */
            .heading-row {
                margin-left: 0 !important;
            }

            /* NEWSLETTER line */


            /* each article card */
            .article-wrap>hr {
                margin-left: 0 !important;
                width: 80% !important;
            }

            /* red bar */
            .heading-word {
                font-size: 34px !important;
                line-height: 38px !important;
            }

            .heading-bar {
                display: block !important;
                /* show it */
                width: 100% !important;
                /* span the full screen width */
                margin: 10px 0 0 0 !important;
                /* sit just below “NEWSLETTER”; no left margin */
                margin-bottom: 10px !important;
                height: 5px !important;
            }

            .unsubscribe {
                font-size: 16px;
            }

            .middlePart{
              width:70%;
            }

            .sideParts{
              width:15%;
            }


            .social{
              flex-direction: column;
            }
        }

        @media only screen and (max-width: 700px) and (min-width:600px) {
            h1.heading-word {
                font-size: 18px !important;
            }
        }

        @media only screen and  (min-width:700px) {
            h1.heading-word {
                font-size: 26px !important;
            }
        }






        @media only screen and (min-width: 950px) {
            h1.heading-word {
                font-size: 44px !important;
            }
        }




    </style>
</head>

<body>
    <div class="container">
        <div class="header">
            <div class="prviText" style="color:#333 ; padding-top:10px; ">
                <span style="text-decoration:underline ; font-size:16px;">Pogledajte e-mail u browseru </span> | avaz.ba
            </div>
            <hr style="border: 0; height: 1px; background: #ccc; margin: 10px auto; width: 100% ; margin-bottom:30px;">
            <div class="container-slike">
                <img src="https://cdn.avaz.ba/newsletter-banners/3372bef4-e488-4f1a-a13e-353d94f5dcf2.png" alt="Avaz Logo" style="width:70%" />
            </div>
        </div>

        <!-- Example date placeholder -->
        <div class="date">${formattedDate}</div>

        <hr style="border: 0; height: 1px; background: #ccc; margin: 10px auto; width: 80% ; ">


        <div>

            <hr style="
          border: 0;
          height: 1px;
          background: #ccc;
          margin: 10px auto;
          width: 100%;
          " />
        </div>
        <div class="heading-row" style="display:flex;align-items:center;margin:2px 0 3px 0px;width:100%">
            <h1 class="heading-word"
                style="color:#EC2128;font-weight:bold;margin:0;white-space:nowrap;padding-right:10px;width:50%;text-align:right">
                NEWSLETTER</h1>
            <hr class="heading-bar" style="flex-grow:1;border:none;height:8px;background:#D50000;margin:0">
        </div>

        <p class="obav">
            Poštovani čitatelji, donosimo vam najčitanije priče na
            najposjećenijem portalu Avaz.ba
        </p>

        <div style="display:grid;gap:20px;width: 100%;max-width: 700px;">

            <!-- Here is where we loop through selectedArticles -->
            ${selectedArticles
              .map((article, index) => {
                // For example, color #F0ECE9 for the 2nd, 4th, 6th, etc. articles:
                const bgColor = index % 2 === 1 ? '#F0ECE9' : 'transparent';

                return `
            <div class="article-wrap"
                style="max-width:700px;width:100%;background-color:${bgColor};overflow:visible; gap: 20px;">

                <div class="article" style="
                  max-width:  100%;
                  margin:0;
                  display: flex;
                  align-items: center;
                  flex-direction: column;

                  border-bottom: none !important;
                ">

                    <div style="margin:0 auto" class="middlePart">


                        <hr class="glavniHr" style="border:0;height:8px;background:#D50000; width:100%;
                        @media only screen and (max-device-width:600px){
                          width:50% !important;
                          margin:0 auto !important;
                          height:5px !important;
                        }
                    " />

                        <div class="govno" style="text-align: center;">

                            <img src="${article.thumbnailImage?.thumbnailUrl || 'https://via.placeholder.com/100'}"
                                alt="${article.title}" style="
                              width: 100%;
                              border-radius: 6px;
                              margin-bottom: 10px;
                            " />
                        </div>

                    </div>


                    <!-- Article Content -->
                    <div style="display:flex;width:100%">

                        <!-- desktop copy -->
                        <div class="stamp-row sideParts" style="display:flex;align-items:flex-start;">
                            <span class="paginacija" style="font-family:'Didot','Playfair Display',serif;
                                      font-size:100px;line-height:84px;color:#E0E0E0;">
                                ${index + 1}
                            </span>


                        </div>

                        <!-- mobile copy, starts hidden -->
                        <!-- mobile copy, shows on ≤600 px -->

                        <div style="width:80%">
                            <span class="stamp-text" style="font-family:'Google Sans',Roboto,Arial,sans-serif;
                          font-size:25px;line-height:29px;font-weight:400;
                          color:rgb(46,43,44);margin-left:0px; margin-top:50px;">
                                ${article.stamp}
                            </span>


                            <p class="article-titleX" style="font-family:'Google Sans',Roboto,Arial,sans-serif;
                            font-size:36px;
                            font-weight:500;
                            line-height:42px;
                            margin-bottom:10px;
                            color:rgb(46,43,44);">
                                ${article.title || 'Nema sadržaja'}
                            </p>



                            <p class="articleSubtitle"
                                style="font-family: 'Google Sans', Roboto, Arial, sans-serif; font-size:20px; ">${
                                  article.subtitle
                                }</p>


                            <a href="${process.env.SHAZAM_APP_API_URL + '/' + article.external_link}" style="
                      color: #d32f2f;
                      font-weight: bold;
                      text-decoration: none;
                      margin-top:20px;
                    ">
                                Pročitaj više
                            </a>


                        </div>

                        <div class="sideParts"></div>
                    </div>
                </div>
            </div>

            ${
              (index + 1 === 2 || index + 1 === 4) && banners[index + 1 === 2 ? 0 : 1]
                ? `
            <div style="width: 100%; background-color: #ffffff;">
                <div class="article" style="display: flex;align-items: center;justify-content: center;border-bottom: none;">
                    <a href="${
                      banners[index + 1 === 2 ? 0 : 1].link || '#'
                    }" target="_blank" style="text-align:center; display:block;">
                        <img class="slikica" src="${banners[index + 1 === 2 ? 0 : 1].imageUrl}" alt="Newsletter Banner"
                            style="width: 100%; max-width:360px; border-radius: 6px; display: block;" />
                    </a>
                </div>
            </div>
            `
                : ''
            }

            `;
              })
              .join('')}

        </div>

        <!-- FOOTER AREA -->
        <div class="footer">


            <!-- App Store & Google Play Section -->
            <div style="text-align: center; ">
                <!-- Red Title Section Above App Heading -->
                <div style="text-align: center; padding: 15px 0; width:100%">
                    <p style="
      color: #e60000;
      font-size: 30px;
      font-weight: 400;
      margin: 0;
      font-family: 'Google Sans', Roboto, Arial, sans-serif;


    ">
                        Pogledaj najnovije vijesti na Avaz.ba
                    </p>
                    <p style="
      color: rgb(46,43,44);
      font-size: 16px;
      margin: 5px 0 15px 0;
      font-weight:italic
      font-family: 'Google Sans', Roboto, Arial, sans-serif;


    ">
                        Pogledajte najnovije vijesti i budite u toku s najvažnijim
                        <br>dešavanjima iz BiH i svijeta.
                    </p>
                    <hr style="
              border: 0;
              height: 1px;
              background: #ccc;
              margin-top: 30px;
              width: 80%;
            " />
                </div>

                <h3 style="
              font-size: 30px;
              color: #333;
              margin-bottom: 10px;
              font-weight: bold;
            ">
                    Dnevni avaz aplikacija
                </h3>
                <div class="social" style="
              display: flex;
              justify-content: center;
              align-items: center;
              gap: 20px;
            ">
                    <a href="https://apps.apple.com/ba/app/avaz/id584780409?l=hr" target="_blank">
                        <img src="https://cdn.freelogovectors.net/wp-content/uploads/2021/01/apple-store-logo-freelogovectors.net_.png"
                            alt="Apple Store" style="height: 30px;" />
                    </a>
                    <a href="https://play.google.com/store/apps/details?id=ba.leftor.avaz&hl=hr&pli=1" target="_blank">
                        <img src="https://upload.wikimedia.org/wikipedia/commons/7/7a/Google_Play_2022_logo.svg"
                            alt="Google Play" style="height: 30px;" />
                    </a>
                </div>
                <hr style="
              border: 0;
              height: 1px;
              background: #ccc;
              margin-top: 30px;
              width: 80%;
            " />
            </div>

            <!-- Social Media Icons -->
            <div style="text-align: center; padding: 15px 0;" >
                <div style="
              display: flex;
              justify-content: center;
              gap: 15px;
            ">
                    <a href="https://www.facebook.com" target="_blank">
                        <img src="https://cdn.avaz.ba/newsletter-banners/26796e73-5bb6-486f-af45-6631b3887e7e.png" alt="Facebook"
                            style="width: 40px; height: 40px;" />
                    </a>
                    <a href="https://www.instagram.com" target="_blank">
                        <img src="https://cdn.avaz.ba/newsletter-banners/d3621595-30c0-4a04-bae5-b218ac828f0c.png" alt="Instagram"
                            style="width: 40px; height: 40px;" />
                    </a>
                    <a href="https://www.twitter.com" target="_blank">
                        <img src="https://cdn.avaz.ba/newsletter-banners/a323e9e2-9d5d-4991-a499-fb7ebb5677fb.png" alt="Twitter"
                            style="width: 40px; height: 40px;" />
                    </a>
                    <a href="https://www.youtube.com" target="_blank">
                        <img src="https://cdn.avaz.ba/newsletter-banners/e21ccc1c-7201-422c-8615-acd88de77455.png" alt="YouTube"
                            style="width: 40px; height: 40px;" />
                    </a>
                </div>
                <hr style="
              border: 0;
              height: 1px;
              background: #ccc;
              margin-top: 30px;
              width: 80%;
            " />
            </div>

            <div class="unsubscribe" style="padding-bottom: 30px;">
                <a style="color: #333; font-size: 15px;">Ako ne želite primati ovakve e-mailove, možete se odjaviti
                    klikom na ovaj <span style="color: red;">link</span></a>
            </div>
            <hr style="
              border: 0;
              height: 1px;
              background: #ccc;
              margin-bottom: 30px;
              width: 80%;
            " />
            <div class="container-slike">
            <a href="https://avaz.ba">
                <img src="https://cdn.avaz.ba/newsletter-banners/3372bef4-e488-4f1a-a13e-353d94f5dcf2.png" alt="Avaz Logo" style="width:60%" />
            </a>
            </div>

            <div style="margin-top: 20px;">
                Vlasnik autorskih prava &copy; avaz-roto press d.o.o. ISSN
                1840-3522.<br />
                Zabranjeno preuzimanje sadržaja bez dozvole izdavača.
            </div>
        </div>
        <!-- /FOOTER AREA -->
    </div>
</body>

</html>
      `;
  };

  // ──────────────────────────────────────────────────────────────────────────
  // Send Newsletter
  const sendNewsletter = async () => {
    if (!newsletterTitle) {
      message.error('Molimo unesite naslov newslettera.');
      return;
    }
    if (selectedArticles.length === 0) {
      message.error('Molimo odaberite barem jedan članak.');
      return;
    }

    setIsSending(true);
    try {
      const resp = await fetch(`${process.env.REACT_APP_API_URL}/api/newsletter/send-newsletter`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          emails: ['nedimdev@proton.me'],
          subject: newsletterTitle,
          content: generateNewsletter(),
          html: generateNewsletter(),
          articles: selectedArticles.map((i: any) => {
            return {
              id: i.id,
              stamp: i.stamp,
              title: i.title,
              subtitle: i.subtitle,
              image: i.thumbnailImage?.thumbnailUrl || 'https://via.placeholder.com/100',
              external_link: process.env.SHAZAM_APP_API_URL + i.external_link,
            };
          }),
          banners: banners.map((j: any) => {
            return {
              imageUrl: j.imageUrl,
              link: j.link,
              id: j.id,
            };
          }),
        }),
      });

      const data = await resp.json();
      if (resp.ok) {
        message.success('Newsletter uspješno poslan!');
      } else {
        message.error(`Neuspješno slanje: ${data.message}`);
      }
    } catch (error) {
      console.error('Greška pri slanju newslettera:', error);
      message.error('Došlo je do greške pri slanju.');
    } finally {
      setIsSending(false);
    }
  };

  // ──────────────────────────────────────────────────────────────────────────
  // RENDER
  return (
    <div style={{ padding: '20px', maxWidth: '100%', margin: 'auto' }}>
      <Card style={{ padding: '20px', boxShadow: '0 4px 8px rgba(0,0,0,0.1)', borderRadius: '10px' }}>
        <Title level={3} style={{ textAlign: 'center', marginBottom: '20px' }}>
          📰 Kreiranje Newslettera
        </Title>

        {/* Search Field */}
        <Input
          placeholder="🔍 Pretraži članke..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          style={{ marginBottom: '15px', fontSize: '16px', padding: '10px' }}
        />

        {/* Newsletter Title */}
        <Input
          placeholder="Naslov Newslettera"
          value={newsletterTitle}
          onChange={(e) => setNewsletterTitle(e.target.value)}
          style={{ marginBottom: '15px', fontSize: '16px', padding: '10px' }}
        />

        {/* TABLE 1: Najnoviji Članci (WITH Pagination) */}
        <Table
          dataSource={transform(filteredArticles, [])}
          loading={isLoading}
          rowKey="id"
          pagination={{
            current: latestPage,
            pageSize: 5,
            total: filteredArticles.length,
            showSizeChanger: false,
            onChange: (page) => setLatestPage(page),
          }}
          title={() => '📢 Najnoviji Članci'}
        >
          <Column
            title="Odaberi"
            render={(_, article: Article) => (
              <Checkbox
                checked={selectedArticles.some((a) => a.id === article.id)}
                onChange={(e) => handleSelectArticle(article, e.target.checked)}
              />
            )}
          />
          <Column title="Naslov članka" dataIndex="title" />
          <Column
            title="Slika"
            render={(_, article: Article) => (
              <img
                src={article?.thumbnailImage?.thumbnailUrl}
                alt="thumbnail"
                style={{ width: '50px', height: '50px', objectFit: 'cover', borderRadius: '4px' }}
              />
            )}
          />
        </Table>

        {/* TABLE 2: Najčitaniji Članci (WITH Pagination) */}
        <Table
          dataSource={mostReadArticles}
          loading={isLoadingMostRead}
          rowKey="id"
          pagination={{
            current: mostReadPage,
            pageSize: 5,
            total: mostReadArticles.length,
            showSizeChanger: false,
            onChange: (page) => setMostReadPage(page),
          }}
          title={() => '🔥 Najčitaniji Članci'}
        >
          <Column
            title="Odaberi"
            render={(_, article: Article) => (
              <Checkbox
                checked={selectedArticles.some((a) => a.id === article.id)}
                onChange={(e) => handleSelectArticle(article, e.target.checked)}
              />
            )}
          />
          <Column title="Naslov članka" dataIndex="title" />
          {/* A column to show the number of hits if your API returns it: */}
          <Column title="Citanost" render={(_, article: any) => article?.numberOfHits ?? 'N/A'} />
          <Column
            title="Slika"
            render={(_, article: Article) => (
              <img
                src={article?.thumbnailImage?.thumbnailUrl || 'https://via.placeholder.com/50'}
                alt="thumbnail"
                style={{ width: '50px', height: '50px', objectFit: 'cover', borderRadius: '4px' }}
              />
            )}
          />
        </Table>

        {/* Preview of the newsletter */}
        <Card title="📩 Pregled Newslettera" style={{ marginTop: 20, borderRadius: '10px' }}>
          <div dangerouslySetInnerHTML={{ __html: generateNewsletter() }} />
        </Card>

        {/* Send Button */}
        <Space style={{ marginTop: 20, width: '100%', justifyContent: 'center' }}>
          <Button type="primary" onClick={() => setConfirmVisible(true)} loading={isSending}>
            Pošalji Newsletter
          </Button>
        </Space>
      </Card>
      <Modal
        title="Potvrda slanja newslettera"
        visible={confirmVisible}
        centered
        onOk={() => {
          sendNewsletter();
          setConfirmVisible(false);
        }}
        onCancel={() => setConfirmVisible(false)}
        okText="Da, pošalji"
        cancelText="Otkaži"
        width={600} // you can make it even wider if you want
      >
        <p style={{ fontSize: '16px', textAlign: 'center', padding: '10px 0' }}>
          Jeste li sigurni da želite poslati ovaj newsletter svim pretplatnicima?
        </p>
      </Modal>
    </div>
  );
};

export default Newsletter;
